import { render, staticRenderFns } from "./AddDynamic.vue?vue&type=template&id=68277050&scoped=true"
import script from "./AddDynamic.vue?vue&type=script&lang=js"
export * from "./AddDynamic.vue?vue&type=script&lang=js"
import style0 from "./AddDynamic.vue?vue&type=style&index=0&id=68277050&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68277050",
  null
  
)

export default component.exports